import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import ControlLeft from './components/control-left.vue';
import DeviceList from './components/device-list.vue';
import FullScreen from '@blade/common/components/full-screen.vue';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
let default_1 = class extends Vue {
    srcMsg = require('@blade/common/assets/svgs/enlarge.svg');
    srcMsg2 = require('@blade/common/assets/svgs/narrow.svg');
    onFullScreenFlag = false;
    title = '';
    groupId = 0;
    logData = '';
    keywords = '';
    activeName = 'first';
    devicesList = [];
    createDeviceNext() {
        this.title = '';
    }
    handleCreate() {
        this.$router.push('/users/control/createDevice');
    }
    handleBulkImport() {
        this.$router.push('/device/bulk-import');
    }
    handleSearch() {
        this.$refs.deviceList1.refresh();
    }
    handleRefresh() {
        this.$refs.deviceList1.refresh();
    }
    mounted() { }
    onFullScreen() {
        const isFullScreen = !!document.fullscreenElement;
        if (isFullScreen)
            document.exitFullscreen();
        else
            document.body.requestFullscreen();
        // this.fullscreen = !isFullScreen;
    }
    // onFullScreen() {
    //   this.onFullScreenFlag = !this.onFullScreenFlag;
    //   (this.$refs.fullscreen as any).toggle();
    // }
    handleExit() { }
    getroupId(val) {
        console.log(val);
        if (this.groupId !== val) {
            this.groupId = val;
            setTimeout(() => {
                this.$refs.deviceList1.refresh();
            }, 100);
        }
    }
    handleExport() {
        this.$refs.deviceList1.exportCsv();
    }
};
default_1 = __decorate([
    Component({
        name: 'Log',
        components: {
            DeviceList,
            // CreatePortraitLibrary,
            FullScreen,
            ControlLeft,
            AuthItem,
        },
    })
], default_1);
export default default_1;
